// `/debug/quiz` — renders a report card for every score (0–100% in steps of
// 10) so all grade / decoration / underline layouts can be spot-checked at
// once. Episodes cycle 2–8 to vary the circle PNG and title length.
// TEMPORARY — remove this route (and src/pages/DebugQuiz.{tsx,scss}) before launch.
import { ScaledReportCard } from '../components/ReportCard';
import { gradeFor } from '../lib/grade';
import { episodeTitle } from '../data/episodes';
import type { QuizResult } from '../state/flow';
import './DebugQuiz.scss';

const TOTAL = 10;
const EPISODES = [2, 3, 4, 5, 6, 7, 8];

// Varied name lengths to exercise the cursive-name width fit (short → long).
const NAMES: ReadonlyArray<readonly [string, string]> = [
  ['Jo', 'Ng'],
  ['Jon', 'Webb'],
  ['Jordan', 'Webb'],
  ['Hannah', 'Wells'],
  ['Jonathan', 'Reyes'],
  ['Maximilian', 'Stout'],
  ['Anne-Sophie', 'Beauchamp'],
  ['Christopher', 'Pemberton'],
  ['Bartholomew', 'Witherspoon'],
  ['Liam', "O'Brien"],
  ['Aleksandra', 'Vasilevska'],
];

export default function DebugQuiz() {
  const cards = Array.from({ length: TOTAL + 1 }, (_, correct) => correct); // 0..10

  return (
    <div className="debug-quiz">
      <header className="debug-quiz__head">
        <h1>Report card QA grid</h1>
        <p>Every score 0–100% (×10). Episodes cycle 2–8 to vary the ring + title.</p>
      </header>

      <div className="debug-quiz__grid">
        {cards.map((correct, i) => {
          const episode = EPISODES[i % EPISODES.length];
          const grade = gradeFor(correct, TOTAL);
          const [firstName, lastName] = NAMES[i % NAMES.length];
          const result: QuizResult = { episode, correct, total: TOTAL, firstName, lastName };
          return (
            <figure key={correct} className="debug-quiz__cell">
              <ScaledReportCard result={result} variant="full" />
              <figcaption className="debug-quiz__cap">
                {grade.pct}% · {grade.letter} · {grade.decoration} · Ep {episode}:{' '}
                {episodeTitle(episode)}
              </figcaption>
            </figure>
          );
        })}
      </div>
    </div>
  );
}
